export default {
  methods: {
    downloadAttachment: function (attachments) {
      const { type, key, metadata, url } = attachments[this.carouselPosition]
      if (type === 'image') {
        this.triggerDownload(url, `${key}.${metadata.type.substring(6)}`)
      } else if (type === 'video') {
        this.triggerDownload(metadata.direct_url, metadata.name)
      } else {
        this.triggerDownload(url, metadata.name)
      }
    },
    triggerDownload: function (url, filename) {
      const xhr = new XMLHttpRequest()
      xhr.open('GET', url, true)
      xhr.onprogress = event => {
        this.$refs.downloadProgress.setValue(event.loaded)
        this.$refs.downloadProgress.setMax(event.total)
      }
      xhr.responseType = 'blob'
      xhr.onload = () => {
        if (xhr.status !== 200) {
          console.log(`Error ${xhr.status}: ${xhr.statusText}`)
        } else {
          const el = document.createElement('a')
          el.href = URL.createObjectURL(xhr.response)
          el.setAttribute('download', filename)
          el.setAttribute('target', '_blank')
          el.click()
          this.$refs.downloadProgress.toggle()
          this.$refs.downloadProgress.reset()
        }
      }
      this.$refs.downloadProgress.toggle()
      xhr.send()
    }
  }
}
